/* IZU Paros: inline header search with live predictive suggestions (Shopify Predictive Search API). Plain JavaScript. */
(() => {
  const toggle = document.querySelector("[data-search-toggle]");
  const panel = document.getElementById("search");
  if (!toggle || !panel) return;
  const input = panel.querySelector("[data-search-input]");
  const list = panel.querySelector("[data-search-results]");
  const status = panel.querySelector("[data-search-status]");
  const closeBtn = panel.querySelector("[data-search-close]");
  const form = panel.querySelector("form");
  const desktop = window.matchMedia("(min-width: 961px)");
  const suggestUrl = panel.dataset.suggestUrl || "/search/suggest";
  const searchUrl = panel.dataset.searchUrl || "/search";
  const currency = panel.dataset.currency || "EUR";
  let timer = null, ctl = null, lastQ = "";

  const money = v => {
    const n = Number(v); if (!isFinite(n)) return "";
    try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: "currency", currency, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(n); }
    catch (e) { return String(v); }
  };
  const esc = s => String(s).replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

  function place() {
    if (!desktop.matches) { panel.style.removeProperty("--search-left"); return; }
    const w = Math.min(480, window.innerWidth - 32), r = toggle.getBoundingClientRect();
    panel.style.setProperty("--search-left", Math.max(16, Math.min(r.left - 12, window.innerWidth - w - 16)) + "px");
  }
  function open() {
    if (panel.classList.contains("is-open")) return;
    place();
    panel.hidden = false;
    requestAnimationFrame(() => { panel.classList.add("is-open"); });
    toggle.setAttribute("aria-expanded", "true");
    document.body.classList.add("search-open");
    setTimeout(() => input.focus({ preventScroll: true }), 30);
  }
  function close(returnFocus) {
    if (!panel.classList.contains("is-open")) return;
    panel.classList.remove("is-open");
    toggle.setAttribute("aria-expanded", "false");
    document.body.classList.remove("search-open");
    if (ctl) ctl.abort();
    setTimeout(() => { if (!panel.classList.contains("is-open")) panel.hidden = true; }, 320);
    if (returnFocus) toggle.focus();
  }

  toggle.addEventListener("click", e => { e.preventDefault(); panel.classList.contains("is-open") ? close(true) : open(); });
  closeBtn.addEventListener("click", () => close(true));
  document.addEventListener("keydown", e => { if (e.key === "Escape" && panel.classList.contains("is-open")) { e.preventDefault(); close(true); } });
  document.addEventListener("click", e => { if (panel.classList.contains("is-open") && !panel.contains(e.target) && !toggle.contains(e.target)) close(false); });
  window.addEventListener("resize", () => { if (panel.classList.contains("is-open")) place(); });
  const burger = document.getElementById("burger"); if (burger) burger.addEventListener("click", () => close(false));

  function render(products, q) {
    if (!products.length) {
      list.innerHTML = `<li class="search__empty">No matches for &ldquo;${esc(q)}&rdquo;. Press Enter to search everything.</li>`;
      status.textContent = "No suggestions";
      return;
    }
    list.innerHTML = products.map(p => {
      const img = p.image ? `<img src="${esc(p.image)}" alt="" width="48" height="64" loading="lazy">` : "";
      const price = money(p.price);
      return `<li><a class="search__item" href="${esc(p.url)}"><span class="search__thumb">${img}</span><span class="search__text"><span class="search__name product-title product-title--small">${esc(p.title || "")}</span>${price ? `<span class="search__price">${esc(price)}</span>` : ""}</span></a></li>`;
    }).join("") + `<li class="search__all"><a class="more-link" href="${esc(searchUrl)}?q=${encodeURIComponent(q)}&type=product">View all results <span aria-hidden="true">&rarr;</span></a></li>`;
    status.textContent = `${products.length} suggestion${products.length === 1 ? "" : "s"}`;
  }

  function fetchSuggestions(q) {
    if (ctl) ctl.abort();
    ctl = new AbortController();
    panel.classList.add("is-loading");
    const url = `${suggestUrl}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
    fetch(url, { signal: ctl.signal, headers: { Accept: "application/json" } })
      .then(r => { if (!r.ok) throw new Error("search " + r.status); return r.json(); })
      .then(j => { if (q !== input.value.trim()) return; render((j.resources && j.resources.results && j.resources.results.products) || [], q); panel.classList.remove("is-loading"); })
      .catch(err => { if (err.name === "AbortError") return; panel.classList.remove("is-loading"); list.innerHTML = ""; status.textContent = ""; });
  }

  input.addEventListener("input", () => {
    const q = input.value.trim();
    clearTimeout(timer);
    if (q.length < 2) { if (ctl) ctl.abort(); list.innerHTML = ""; status.textContent = ""; panel.classList.remove("is-loading"); lastQ = ""; return; }
    if (q === lastQ) return;
    lastQ = q;
    timer = setTimeout(() => fetchSuggestions(q), 200);
  });
  panel.addEventListener("keydown", e => {
    if (e.key !== "ArrowDown" && e.key !== "ArrowUp") return;
    const items = Array.from(list.querySelectorAll("a")); if (!items.length) return;
    const i = items.indexOf(document.activeElement);
    e.preventDefault();
    if (e.key === "ArrowDown") (items[i + 1] || items[0]).focus();
    else if (i <= 0) input.focus(); else items[i - 1].focus();
  });  form.addEventListener("submit", e => { if (input.value.trim().length < 1) e.preventDefault(); });
  // Suggestion chips (shown while the box is empty): search that word right here instead of leaving the page.
  panel.addEventListener("click", e => {
    const chip = e.target.closest("[data-search-term]"); if (!chip) return;
    e.preventDefault();
    input.value = chip.dataset.searchTerm;
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.focus({ preventScroll: true });
  });
})();
